import { queryOptions } from '@tanstack/react-query'
import { apiRequest } from '@/shared/api'
import { MeetingSchema } from '../model/types'

// Контур встреч: проект или компания. Лента компании несёт и встречи самой
// компании, и встречи всех её проектов.
export type MeetingScope = { kind: 'project'; id: string } | { kind: 'company'; id: string }

export const meetingKeys = {
  all: ['meeting'] as const,
  byProject: (projectId: string) => ['meeting', 'project', projectId] as const,
  byCompany: (companyId: string) => ['meeting', 'company', companyId] as const,
  detail: (id: string) => ['meeting', 'detail', id] as const,
}

export function meetingScopeKey(scope: MeetingScope) {
  return scope.kind === 'project'
    ? meetingKeys.byProject(scope.id)
    : meetingKeys.byCompany(scope.id)
}

// Путь ленты и создания: контур решает префикс, ручка одна и та же.
export function meetingScopeUrl(scope: MeetingScope): string {
  return scope.kind === 'project'
    ? `/projects/${scope.id}/meetings`
    : `/companies/${scope.id}/meetings`
}

// Карточка встречи (страница встречи). Заказчику приходит только помеченная —
// непомеченная отвечает 404 (existence-hiding).
export function meetingDetailQueryOptions(id: string) {
  return queryOptions({
    queryKey: meetingKeys.detail(id),
    queryFn: async () =>
      MeetingSchema.parse(await apiRequest({ method: 'GET', url: `/meetings/${id}` })),
  })
}
